import { EndpointError } from '@square/ignition';
import { Box, Paragraph20 } from '@squareup/dex-ui-shared-base';
import { getHttpCodeDescription } from '@squareup/dex-utils-error';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';

import { ReferenceCodeBlock } from '../ReferenceCodeBlock';

import styles from './error-code-example-aside-layout.module.css';

interface ErrorCodeExampleAsideLayoutProps {
  selectedError: EndpointError;
}

const ErrorCodeExampleAsideLayout: FunctionComponent<
  ErrorCodeExampleAsideLayoutProps
> = ({ selectedError }) => {
  return (
    <Box
      className={styles['floating-block']}
      margin={{ bottom: '4x', top: '9x' }}
    >
      <Box margin={{ bottom: '5x' }} className={clsx(styles['code-block'])}>
        <ReferenceCodeBlock
          title={
            <Paragraph20 weight="semi-bold">
              {selectedError.httpCode} {getHttpCodeDescription(selectedError)}
            </Paragraph20>
          }
          code={generateExample(selectedError)}
          currentLanguage={'json'}
        />
      </Box>
    </Box>
  );
};

function generateExample(endpointError: EndpointError) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorJson: any = {
    code: endpointError.code,
  };

  if (endpointError.category) {
    errorJson.category = endpointError.category;
  }

  return JSON.stringify(
    {
      errors: [errorJson],
    },
    null,
    '  '
  );
}

export { ErrorCodeExampleAsideLayout };
